import { Box, Container, Grid, Typography } from "@mui/material";

const PointList = ({ title, points }) => {
  return (
    <Box>
      <Typography
        variant="h3"
        sx={{
          fontWeight: 800,
          color: "#0b4a92",
          mb: 3,
          fontSize: { xs: "1.5rem", md: "2rem" },
        }}
      >
        {title}:
      </Typography>

      <Box component="ul" sx={{ pl: 3, m: 0 }}>
        {points.map((point, index) => (
          <Typography
            component="li"
            key={index}
            sx={{
              mb: 1.5,
              fontSize: "1rem",
              lineHeight: 1.7,
              color: "#4b5563",
              textAlign: "justify",
            }}
          >
            <Box component="span" sx={{ fontWeight: 700 }}>
              {point.title}:
            </Box>{" "}
            {point.description}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

const ProductPoints = ({ features, benefits }) => {
  return (
    <Box sx={{ py: { xs: 4, md: 5 }, backgroundColor: "none" }}>
      <Container maxWidth="lg">
        <Grid container spacing={6}>
          <Grid size={{ xs: 12, md: 6 }}>
            <PointList title={features.title} points={features.points} />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <PointList title={benefits.title} points={benefits.points} />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ProductPoints;
